/* eslint-disable */
/// <reference path="./utils/exoweb.d.ts" />
import { EntryViewFilterTelemetryTracker } from './entry-view-filter-telemetry';

export default function ({
	canManageEntries,
	appInsights,
	fromPath,
	columnFieldInfoData,
	emitPageReady,
	disableUnreadEntryTracking,
	onRoleAssignmentsUpdated,
	getEntryViews,
	resources,
	getAvatarSVG,
	userEmail,
	userName
}) {
	Cognito.ready("gridview", ["entrylist", "ExoWeb.dom"], function ($) {

		Cognito.Messaging.addHandler("entriesUpdated", function (updatedFormIds) {
			if (updatedFormIds.includes(Cognito.Forms.model.formId) && !refreshing)
				Cognito.Forms.gridController.refreshEntries(null, false, true);
		});

		onRoleAssignmentsUpdated(() => {
			Cognito.Forms.gridController.refreshEntries(null, true, true);
		});

		//#region Global Variables
		var grid;
		var currentEntryKey;
		var selectedEntries = [];
		var loading;
		var refreshing;
		var tracking = false;
		var source = fromPath === '/' ? 'Initial Load' : 'Other';
		var entrySet;
		var currentView;
		var currentFilterInvalid;
		var shortUserId;
		var initialized;
		var readStates = {};
		var refreshInterval;
		var progressBarWidth = 0;
		var previousProgressNum = 0;
		var failedSignatureUrls = [];
		var winHeight = window.innerHeight;
		var winWidth = window.innerWidth;
		var rowHeight = winWidth < 900 ? 40 : (winHeight < 700 ? 32 : winHeight < 900 ? 34 : 36);
		var indexesBuilt = false;
		var fieldInfos = [];
		var gridResizeObserver;
		var filterTelemetryTracker = new EntryViewFilterTelemetryTracker({
			appInsights: appInsights,
			getCurrentView: function () { return currentView; },
			getFormId: function () { return Cognito.Forms.model.formId; },
			serializeFilter: serializeFilter
		});
		document.documentElement.style.setProperty("--row-height", rowHeight + "px");

		//#endregion

		/**
		 * Returns a function that will call the underlying callback as long as the form has not changed.
		 * @param {Function} callback The underlying callback to invoke
		 * @returns A function that conditionally calls the given callback.
		 */
		function checkForm(callback) {
			if (!Cognito.Forms.model.formId) {
				console.warn('Cannot bind a callback prior to the form id being established.');
				return callback;
			}

			let capturedFormId = Cognito.Forms.model.formId;

			return function checkFormCallback() {
				if (!window.Cognito || !Cognito.Forms || !Cognito.Forms.model || Cognito.Forms.model.formId !== capturedFormId) {
					console.log('Discarding callback due to form change from ' + capturedFormId + ' to ' + (window.Cognito && Cognito.Forms.model && Cognito.Forms.model.formId) + '.');
					return;
				}

				// Call the original callback
				return callback.apply(this, arguments);
			};
		}

		/**
		 * Returns a function that will call the underlying callback as long as the `grid` variable has not changed.
		 * @param {Function} callback The underlying callback to invoke
		 * @see grid
		 * @returns A function that conditionally calls the given callback.
		 */
		function checkGrid(callback) {
			if (!grid) {
				console.warn('Cannot bind a callback prior to creation of the grid.');
				return callback;
			}

			let capturedGrid = grid;

			return function checkGridCallback() {
				if (grid !== capturedGrid) {
					console.log('Discarding callback due to grid change.');
					return;
				}

				// Call the original callback
				callback.apply(this, arguments);
			};
		}

		function serializeFilter(filter) {
			if (!filter)
				return {};

			return filter.meta ? Cognito.serialize(filter) : JSON.parse(JSON.stringify(filter));
		}

		/**
		 * Returns true if the provided fieldSubType is multi-select; false otherwise
		 * @param {FieldSubType} fieldSubType The FieldSubType
		 * @returns true if the provided fieldSubType is multi-select; false otherwise
		 */
		function isMultiSelect(fieldSubType) {
			return fieldSubType == "Checkboxes" || fieldSubType == "MultiSelectCards";
		}

		$extend("Cognito.Forms.EntryView", function (type) {
			var isUserSpecificProp = type.meta.addProperty({ name: "isUserSpecific", type: Boolean, origin: "server" }).defaultValue(false);
			isUserSpecificProp._origin = "server";
			isUserSpecificProp._isPersisted = true;
		});

		//#region Controller

		function updateProgressBar(num, interval) {
			// If the previous num was greater than the new num it will show the progress going backwards
			if (Math.round(num) < Math.round(previousProgressNum))
				$("#progress-bar-value").css({ transitionDuration: 0 + "ms" });
			else
				$("#progress-bar-value").css({ transitionDuration: (interval + 1000) + "ms" });

			if (num >= progressBarWidth) {
				$("#progress-bar-value").css({ width: num + "%" });
				progressBarWidth = num;
			}

			if (num == 100) {
				$("#progress-bar-value").on('transitionend', function () {
					if (!Cognito.Forms.model.entries)
						updateProgressMessage("Loading...");
					$("#progress").removeClass("c-entries-loading");
				});
				progressBarWidth = 0;
			} else {
				indexesBuilt = true;
				updateProgressMessage("Preparing...");
			}

			if (num < 100)
				$("#progress").addClass("c-entries-loading");

			if (!isNaN(num))
				previousProgressNum = num;
		}

		// Top Controller
		var controller;
		if (ExoWeb.evalPath(window.parent, 'Cognito.Forms.controller')) {
			Cognito.ready("Cognito.Forms.controller");
		}
		else {
			Cognito.Messaging.addHandler("controllerReady", function () {
				Cognito.ready("Cognito.Forms.controller");
			});
		}

		Vue.watch(disableUnreadEntryTracking, () => {
			// If tracking unread entries, get readStates if not loaded yet
			if (!disableUnreadEntryTracking.value)
				getEntryReadStates();
			Cognito.Forms.gridController.refreshEntries(null, false, false);
		});

		// Master Controller
		Cognito.Forms.gridController = {

			reset: function() {
				if (gridResizeObserver) {
					gridResizeObserver.disconnect();
				}
				if (grid) {
					grid.destroy();
					grid = null;
				}
				initialized = false;
				Cognito.Forms.model.entries = entrySet = null;
			},

			changeView: function changeView(view, mode, role, changingForm) {
				if (appInsights) {
					tracking = true;
					if (source != 'Initial Load')
						source = 'Other';
					appInsights.startTrackEvent('TimeToGridReady');
				}

				// Destroy grid if changing forms
				if (changingForm || (currentView && currentView.get_Form().get_Id() !== view.get_Form().get_Id())) {
					this.reset();
					source = 'Change Form';
				}
				// Check if this was a change between views
				else if (currentView && view != currentView)
					source = 'Change View'

				// Track the current view
				currentView = view;
				filterTelemetryTracker.reset(view.get_Filter());

				if (currentView.get_Type().get_Name() === "Form")
					return;

				// Disable resize observer while changing views
				if (gridResizeObserver)
					gridResizeObserver.disconnect();

				// Show Loading Message
				updateProgressMessage("Loading...");

				currentFilterInvalid = view.get_Filter().get_Invalid();
				function initEntrySet(observeGridResize) {
					return AdminForm.getEntrySet(
						view.get_Id(),
						view.get_Token(),
						role,
						{ Name: userName.value, Email: userEmail.value },
						view.get_isUserSpecific() ? shortUserId : null
					).then(checkForm(function (newEntrySet) {
						Cognito.Forms.model.entries = entrySet = newEntrySet;

						// Ensure the grid has been initiaized
						if (!grid)
							initializeGrid(observeGridResize);

						return newEntrySet;
					}));
				}

				// Show an error message if the filter is not valid
				if (currentFilterInvalid) {
					updateProgressMessage("Invalid Filter");
					if (!initialized) {
						initEntrySet(true);
						initialized = true;
					}
				}
				// Asynchronously load the set of entries to show in the grid
				else {
					//reset client sort criteria
					if (entrySet)
						entrySet.setSortCriteria(null);

					return initEntrySet(false).then(checkForm(function (entrySet) {
						return entrySet.refresh(updateProgressBar).then(checkForm(function () {
							// Attach resize observer now that entry set is refreshed
							if (!gridResizeObserver)
								attachGridResizeObserver();

							// Update column and sort settings
							Cognito.Forms.gridController.changeColumns(view.get_Columns());
							updateSortIndicators(view.get_SortBy());

							// Bind entry set to the grid
							bindGrid(entrySet);

							if (entrySet.timestamp) {
								var setTimestamp = new Date(entrySet.timestamp);
								var millisecondsSinceUpdate = new Date() - setTimestamp;

								// If this set hasn't been updated in 5 minutes, assert that the index and statistics match
								if (millisecondsSinceUpdate > 5 * 60 * 1000)
									Cognito.Forms.compareEntryCounts(entrySet.view, entrySet.indexes.size, view.get_isUserSpecific());
							}
						}));
					}));
				}
			},

			// Change Layout
			changeLayout: function changeLayout() {
				initializeGrid(true);
			},

			// Change Sort
			changeSort: function changeSort(columns) {
				if (appInsights) {
					tracking = true;
					source = 'Change Sort';
					appInsights.startTrackEvent('TimeToGridReady');
				}

				// Update the view sort columns
				currentView.set_SortBy(columns);

				// Show Sorting Message
				updateProgressMessage("Sorting...", function () {

					// Update sort indicators to reflect the sorting specified for the current view
					updateSortIndicators(columns);

					// Sort the entries
					entrySet.sort(getSortCriteria(columns)).then(checkGrid(function () {
						refreshGrid(true);
						if (!currentEntryKey) grid.scrollRowToTop(0);
					}));
				});
			},

			// Change Filter
			changeFilter: function changeFilter(filter, baseViewData) {
				if (appInsights) {
					tracking = true;
					source = 'Change Filter';
					appInsights.startTrackEvent('TimeToGridReady');
				}

				currentFilterInvalid = filter.get_Invalid();
				// Show Filtering Message
				updateProgressMessage("Filtering...");
				getPreviewEntrySet(baseViewData).then(checkForm(function (result) {
					filterTelemetryTracker.trackApplied(filter, result.temporarySetAction, result.hadActiveTemporarySet);
					bindGrid(result.entrySet);
				}));
			},

			trackFilterSaved: function trackFilterSaved(view) {
				filterTelemetryTracker.trackSaved(view);
			},

			// Change Columns
			changeColumns: function changeColumns(columns) {
				grid.setColumns(grid.getColumns().slice(0, Cognito.config.role === "Guest" ? 1 : 2).concat(getGridColumns(columns)));
			},

			// Refresh Entries
			refreshEntries: function refreshEntries(callback, pollingRefresh = false, backgroundRefresh = false) {
				if (appInsights && !pollingRefresh && !backgroundRefresh) {
					tracking = true;
					source = 'Grid Refresh';
					appInsights.startTrackEvent('TimeToGridReady');
				}
				refreshing = true;
				if (entrySet) {
					entrySet.refresh(updateProgressBar).then(checkGrid(function (newEntrySet) {
						if (newEntrySet)
							bindGrid(newEntrySet);
						else
							refreshGrid(!pollingRefresh && !backgroundRefresh);

						if (typeof callback === 'function') callback();
					}));
				}
			},

			// Update entry read states
			changeReadStates: function changeEntryStates(indexes, read) {
				let updates = [];
				for (let i = 0; i < indexes.length; i++) {
					let index = entrySet.indexOfEntryId(indexes[i].EntryId);
					var entry = entrySet.entryAt(index);
					let status = "";
					if (entry)
						status = entry.Entry.Status;

					// Only allow completed entries to be marked as unread
					if (read || status !== "Incomplete") {
						updates.push(indexes[i]);

						readStates[indexes[i].EntryId] = read;
						grid.invalidateRow(index);
					}
				}
				if (updates.length)
					controller.updateEntryReadState(updates, read);
				grid.render();
			},

			// Clear Selection
			clearSelection: function clearSelection() {
				updateSelectedEntries([], currentEntryKey);
			},

			// View Entry
			viewEntry: function viewEntry(entryKey) {
				updateSelectedEntries([entryKey], entryKey);
			},

			// Hide Entry
			hideEntry: function hideEntry() {
				updateSelectedEntries(currentEntryKey && selectedEntries.length == 1 && selectedEntries[0].EntryId == currentEntryKey.EntryId ? [] : selectedEntries, null);
			},

			// Hide Menus
			hideMenus: function hideMenus() {
				$(".c-menu-open").removeClass("c-menu-open").css("transition", "").css("max-height", "").css("overflow-y", "");
			},

			reportSignatureLoadError: function reportSignatureLoadError(url) {
				if (url && window.appInsights && failedSignatureUrls.indexOf(url) < 0) {
					window.appInsights.trackException(new Error("Offloaded signature image failed to load: " + url));
					failedSignatureUrls.push(url);
				}
			},

			// Update Progress Message
			updateProgressMessage: function (message) {
				updateProgressMessage(message);
			},

			startRefreshInterval: function startRefreshInterval() {
				if (Cognito.config.hasPaidPlan && !Cognito.config.isUnitTesting) {
					function refreshView() {
						if (!refreshing && !$("#progress span").text())
							Cognito.Forms.gridController.refreshEntries(null, true);
					};
					refreshView();

					refreshInterval = Cognito.timers.gridRefreshInterval = window.setInterval(refreshView, 60000);
				}
			},

			stopRefreshInterval: function stopRefreshInterval() {
				clearInterval(refreshInterval);
			}

		};

		//#endregion

		//#region Grid

		function initializeGrid(observeGridResize) {

			if (!grid) {

				// Determine the propery paths and scopes for each field
				fieldInfos = entrySet.getPropertyChains(columnFieldInfoData.value);

				// Intialize Column List
				var checkboxSelector = new Slick.CheckboxSelectColumn({});
				var checkboxColumn = checkboxSelector.getColumnDefinition();
				checkboxColumn.cssClass = "c-checkbox-fancy c-selector-col";
				checkboxColumn.headerCssClass = "c-checkbox-fancy c-selector-col";
				checkboxColumn.reorderable = false;
				checkboxColumn.width = 40;
				checkboxColumn.depth = 0;
				var entryNumberCol = { id: "Entry.Number", name: "#", field: fieldInfos[0].property, width: 50, depth: 0, cssClass: "c-id", sortable: true, reorderable: false, autoSizePadding: 0 };
				var columns = Cognito.config.role === "Guest" ? [entryNumberCol] : [checkboxColumn, entryNumberCol];

				// Add View Columns
				columns = columns.concat(getGridColumns(currentView.get_Columns()));

				// Configure Grid Options
				var options = {
					enableCellNavigation: true,
					multiSelect: Cognito.config.role !== "Guest",
					multiColumnSort: true,
					rowHeight: rowHeight,
					syncColumnCellResize: true,
					dataItemColumnValueExtractor: function (entry, column) {
						if (!entry) {
							return null;
						}
						if (column.field instanceof Object) {
							return column.field.value(entry);
						}
						return null;
					},
					getItemMetadata: function (row) {
						if (this.getItem(row).compareThis > 1) {
							return {
								'cssClasses': 'row-class'
							};
						}
					}
				};

				// Create Grid
				grid = new Slick.Grid("#grid", [], columns, options);

				// Enable Row Selection
				grid.setSelectionModel(new Slick.RowSelectionModel({ selectActiveRow: true }));

				// Enable Checkbox Selector
				grid.registerPlugin(checkboxSelector);

				// Enable Tooltips
				grid.registerPlugin(new Slick.AutoTooltips({ enableForHeaderCells: true }));

				// Handle person field tooltips
				grid.onMouseEnter.subscribe(handleLookupFieldMouseEnter)

				// Enable Auto Column Size
				grid.registerPlugin(new Slick.AutoColumnSize(500));

				// Helper function to get cell data for copy functionality
				function getCellDataForCopy(rightClickedCell) {
					if (!rightClickedCell || rightClickedCell.row < 0 || rightClickedCell.cell < 0)
						return null;

					var entry = entrySet.entryAt(rightClickedCell.row);
					var column = grid.getColumns()[rightClickedCell.cell];

					if (!entry || !column)
						return null;

					// Get field type information from fieldInfos array
					var fieldInfo = fieldInfos.find(function(f) { return f.Id === column.id; });
					var fieldType = fieldInfo ? fieldInfo.FieldType : null;
					var fieldSubType = fieldInfo ? fieldInfo.FieldSubType : null;

					if (fieldType === 'YesNo' || (fieldInfo && fieldInfo.IsProtected))
						return null;

					var value = column.field.value(entry);

					if (value) {
						if (fieldType === 'Email')
							return { label: 'Email', value: value };
						else if (fieldType === 'Website')
							return { label: 'Link', value: value };
						else if (fieldType === 'File') {
							var fileUrl = '';
							var isImage = false;
							 // handle single upload files
							if (value && value.length === 1) {
								var file = value[0];

								// Check if it's an image file
								isImage = file.ContentType.startsWith('image/');

								if (isImage)
									fileUrl = Cognito.getThumbnailUrl(file.Id, file.Name);
								else
									fileUrl = CognitoConfiguration.SiteUrl + 'forms/public/file?id=' + file.Id + '&name=' + encodeURIComponent(file.Name);

								return { label: isImage ? 'Image' : 'File Link', value: fileUrl || String(value) };
							}
							return null;
						}
						else if (fieldType === 'Signature') {
							var imageUrl = '';
							// Handle signature images
							if (value && value.PngFile && value.PngFile.Size > 0)
								imageUrl = Cognito.getThumbnailUrl(value.PngFile.Id, value.PngFile.Name);

							if (imageUrl)
								return { label: 'Image', value: imageUrl };
							else
								return null;
						}
						else if (column.cssClass && column.cssClass.indexOf('c-person') >= 0) { // person field, copy name
							if (value && value.Name && value.Name.FirstAndLast)
								return { label: 'Value', value: value.Name.FirstAndLast };
							else
								return null;
						}
						else {
							var formattedValue = value;

							if (fieldSubType == "Percent") // if a percentage, format as percent
								formattedValue = (Math.max(Math.min(value, 1), 0) * 100).toFixed(2) + "%";
							// else, if the value is an object or a number, make sure to call the formatter
							else if (typeof formattedValue === 'object' || (fieldType == "Number" || fieldType == "Currency" || fieldSubType == "Currency" || fieldSubType == "Decimal")) {
								if (column.formatter && typeof column.formatter === 'function')
									formattedValue = column.formatter(rightClickedCell.row, rightClickedCell.cell, value);
							}

							// Only return non-empty string values
							if (formattedValue && formattedValue.toString()?.trim() !== '')
								return { label: 'Value', value: formattedValue };
							else
								return null;
						}
					}
					else
						return null;
				}

				grid.onContextMenu.subscribe(function (e, args) {
					e.preventDefault();

					var selectedRows = grid.getSelectedRows();
					var rightClickedCell = grid.getCellFromEvent(e);
					var activeRow = grid.getActiveCell() ? grid.getActiveCell().row : undefined;
					var shouldCloseDetailsPane = activeRow != rightClickedCell.row;

					// If the user clicks on a row that isn't in the set of checked entries, select the one that was clicked instead
					if (!selectedRows.includes(rightClickedCell.row) || selectedRows.length <= 1) {
						selectedRows = [rightClickedCell.row];
						grid.setSelectedRows([selectedRows])
					}

					// Get the cell data for copy functionality
					var cellData = getCellDataForCopy(rightClickedCell);

					controller.openActionsMenu(shouldCloseDetailsPane, e.clientX, e.clientY, cellData);
				});

				// Notify the controller when the set of selected entries changes
				grid.onSelectedRowsChanged.subscribe(function (e, args) {
					var currentRow = getCurrentEntryPosition();
					var activeRow = grid.getActiveCell() ? grid.getActiveCell().row : undefined;
					if (activeRow != undefined && activeRow != currentRow) {
						var entryKey = entrySet.entryKeyAt(activeRow);
						entryKey.Read = readStates[entryKey.EntryId];
						controller.viewEntry(entryKey);
						Cognito.Forms.gridController.viewEntry(entryKey);
					}
					else
						updateSelectedEntries(
							grid.getSelectedRows().map(function (row) { return entrySet.entryKeyAt(row); }),
							grid.getActiveCell() ? entrySet.entryKeyAt(grid.getActiveCell().row) : null);
				});

				// Notify the controller when sort changes occur
				grid.onSort.subscribe(function (e, args) {
					controller.changeSort(args.sortCols.map(function (c) { return new Cognito.Forms.EntryViewSort({ FieldId: c.sortCol.id, Ascending: c.sortAsc }); }));
				});

				// Update sort indicators to reflect the sorting specified for the current view
				updateSortIndicators(currentView.get_SortBy());

				// Update the view columns to reflect changes made to the grid
				var onColumnsChanged = function onColumnsChanged(e, args) {
					controller.changeColumns(grid.getColumns().slice(Cognito.config.role === "Guest" ? 1 : 2).map(function (c) { return new Cognito.Forms.EntryViewColumn({ FieldId: c.id, Width: c.width }); }));
				}
				grid.onColumnsReordered.subscribe(onColumnsChanged);
				grid.onColumnsResized.subscribe(onColumnsChanged);

				if (observeGridResize)
					attachGridResizeObserver();

			}

			Cognito.Forms.grid = grid;
		}

		function attachGridResizeObserver() {
			// When grid container is resized, force resize canvas to re-orient scrollbars
			gridResizeObserver = new ResizeObserver(() => {
				grid.resizeCanvas();
			});
			gridResizeObserver.observe(document.getElementById('c-entrylist'));
		}

		// Get Grid Columns
		function getGridColumns(viewColumns) {

			var gridColumns = [];

			// Propogate the column widths for the selected view columns to fields shown in the grid
			var fields = [];
			for (var c = 0; c < viewColumns.length; c++) {
				for (var f = 0; f < fieldInfos.length; f++) {
					if (fieldInfos[f].Id == viewColumns[c].get_FieldId()) {
						fields.push(fieldInfos[f]);
						fields[fields.length - 1].Width = viewColumns[c].get_Width();
					}
				}
			}

			// Add columns for each field in the view
			fields.forEach(function (f) {
				// Field Format
				var cssClass = "";
				var name = f.Name;
				var toolTip = f.Scope ? `${f.Scope} ${name}` : name
				var fieldType = f.FieldType;
				var fieldSubType = f.FieldSubType;
				var format = f.property ? f.property.format : null;
				var formatter;
				var defaultSortAsc = true;
				var isPersonField = !!Cognito.config.personFields[f.Id];

				if (f.Id === 'Entry.Status') {
					name = resources.value.Status;
					toolTip = resources.value.EntryStatus;
					cssClass = f.Width < 50 ? "c-status-cell is-compact" : "c-status-cell";
					formatter = function (row, cell, value) {
						return (value === "Incomplete") ? resources.value.Incomplete : value;
					};
				}

				if (f.Id === 'Entry.DateCreated') {
					name = resources.value.Created;
					toolTip = resources.value.EntryCreated;
				}


				if (f.Id === 'Entry.DateSubmitted') {
					name = resources.value.Submitted;
					toolTip = resources.value.EntrySubmitted;
				}


				if (f.Id == 'Entry.DateUpdated') {
					name = resources.value.Updated;
					toolTip = resources.value.EntryUpdated;
				}

				// Yes/No
				if (fieldType == "YesNo" || fieldSubType == "YesNo") {
					formatter = function (row, cell, value) { return value ? "&#xf00c;" : ""; };
					cssClass = "c-checkbox";
					defaultSortAsc = false;
				}

				// Email
				else if (fieldType == "Email") {
					formatter = function (row, cell, value) { return value ? "<a href='mailto:" + htmlEscape(value) + "'>" + value + "</a>" : ""; };
					cssClass = "c-link";
				}

				// Website
				else if (fieldType == "Website") {
					formatter = function (row, cell, value) { return value ? "<a href='" + htmlEscape(value) + "' target='_blank' rel='noopener noreferrer'>" + value + "</a>" : ""; };
					cssClass = "c-link";
				}

				// Percentage
				else if (fieldSubType == "Percent") {
					formatter = function (row, cell, value) {
						var a = Math.max(Math.min(1 - value * 2, 1), 0);
						var b = (0.5 - Math.min(Math.abs(value - 0.5), 0.5)) * 2;
						var c = Math.max(Math.min(value * 2 - 1, 1), 0);
						var r = Math.round(a * 216 + b * 204 + c * 174);
						var g = Math.round(a * 84 + b * 204 + c * 209);
						var b = Math.round(a * 39 + b * 204 + c * 54);
						return format.convert(value) + "<div style='background-color: rgb(" + r + "," + g + "," + b + "); width: calc(" + (Math.max(Math.min(value, 1), 0) * 100) + "% + 4px);'></div>";
					};
					cssClass = "c-percentage";
				}

				// Number
				else if (fieldType == "Number" || fieldType == "Currency" || fieldSubType == "Currency" || fieldSubType == "Decimal") {
					formatter = function (row, cell, value) { return format.convert(value); };
					cssClass = "c-number";
				}

				// File
				else if (fieldType == "File") {
					formatter = function (row, cell, value) {
						var thumbnails = "";
						if (value) {
							for (var f = 0; f < value.length; f++) {
								var file = value[f];
								thumbnails += "<img src='" + Cognito.getThumbnailUrl(file.Id, file.Name) + "' title='" + htmlEscape(file.Name) + "'  />";
							}
						}
						return thumbnails;
					};
					cssClass = "c-file";
					defaultSortAsc = false;
				}

				// Signature
				else if (fieldType == "Signature") {
					formatter = function (row, cell, value) {
						var imgUrl = "";
						var imgIsOffloaded = false;
						if (value && value.PngFile && value.PngFile.Size > 0) {
							imgUrl = Cognito.getThumbnailUrl(value.PngFile.Id, value.PngFile.Name);
							imgIsOffloaded = true;
						}
						else if (value && value.Png)
							imgUrl = value.Png;
						return imgUrl ? "<img src='" + imgUrl + "' " + (imgIsOffloaded ? "onerror='Cognito.Forms.gridController.reportSignatureLoadError(this.src);' " : "") + "/>" : "";
					};
					cssClass = "c-signature";
					defaultSortAsc = false;
				}

				// Password
				else if (fieldSubType == "Password") {
					formatter = function (row, cell, value) { return value ? Array(value.length + 1).join("*") : ""; };
					cssClass = "c-password";
					defaultSortAsc = false;
				}

				// Order.OrderSummary
				else if (f.Id === "Order.OrderSummary") {
					formatter = function (row, cell, value) {
						if (value) {
							var spaceIndex = value.indexOf(' ');
							if (spaceIndex === -1)
								return "<span>" + value + "</span>";
							return "<span>" + value.substring(0, spaceIndex) + "</span>&nbsp;<span>" + value.substring(spaceIndex + 1) + "</span>";
						}

						return "";
					};
					cssClass = "c-ordersummary";
				}

				// If the field is a person field, render avatars, else render as a normal lookup
				else if (isPersonField && format) {
					cssClass = "c-person";

					var mappings = Cognito.config.personFields[f.Id];

					if (isMultiSelect(fieldSubType)) {
						// Will display an avatar for each respective person
						formatter = function (row, cell, value) {
							if (!(value instanceof Array))
								return "";

							if (value.length === 0)
								return;

							var avatarAndNameElements = [];

							for (var i = 0; i < value.length; i++) {
								var name = htmlEscape(format.convert(value[i]));
								var avatarElement = buildAvatarElement(value[i], name, mappings)
								var isEmptyElement = !avatarElement.trim();
								if (isEmptyElement)
									continue;

								avatarAndNameElements.push(avatarElement);
							}

							// Wrap entire cell in a <div>, and wrap each avatar-name pair in its own <div> to aid styling
							var prefix = "<div class=\"cog-person-field-cell\"><div class=\"cog-person-field-cell__checkbox-selection\">";

							// Close the last checkbox-selection <div> and the person-field-cell <div>
							var suffix = "</div></div>"

							// Close the previous pair's checkbox-selection <div> and open a new one
							var avatarLabelPairs = avatarAndNameElements.join("</div><div class=\"cog-person-field-cell__checkbox-selection\">");

							return prefix + avatarLabelPairs + suffix;
						};
					} else {
						formatter = function (row, cell, value, m, dataContext) {
							if (!value)
								return;

							// This is the value of the name field
							var name = htmlEscape(format.convert(value));
							// For self-reference, the cell value IS the Name composite and image/email live
							// on sibling fields of the row. For lookup, the cell value IS the lookup target
							// entry; the function walks MappedNameFieldPath to extract the Name composite.
							var entryRow = mappings.IsSelfReference ? dataContext : value;
							var nameComposite = mappings.IsSelfReference ? value : undefined;
							var avatarElement = buildAvatarElement(entryRow, name, mappings, nameComposite);

							return "<div class=\"cog-person-field-cell\">" + avatarElement + "</div>";
						};
					}
				}

				else if (fieldType == "Lookup" && isMultiSelect(fieldSubType) && format) {
					formatter = function (row, cell, value) {
						if (value instanceof Array) {
							if (f.MappedFileUploadPath) {
								if (value.length === 0) return "";

								var lookupElements = [];

								for (var i = 0; i < value.length; i++) {
									var lookupEntry = value[i];
									var imageData = getEntryFieldValue(f.MappedFileUploadPath, lookupEntry);
									var lookupElement = buildLookupWithImageCell(lookupEntry, imageData, format, f.MappedFileUploadPath, true);

									var isEmptyElement = !lookupElement.trim();
									if (isEmptyElement) continue;

									lookupElements.push(lookupElement);
								}

								if (lookupElements.length === 0) return "";

								cssClass = "c-lookup-with-image";

								var prefix = "<div class=\"cog-lookup-with-image-cell\"><div class=\"cog-lookup-with-image-cell__checkbox-selection\">";
								var suffix = "</div></div>";
								var lookupPairs = lookupElements.join("</div><div class=\"cog-lookup-with-image-cell__checkbox-selection\">");

								return prefix + lookupPairs + suffix;
							} else {
								var result = "";
								for (var i = 0; i < value.length; i++)
									result += ", " + htmlEscape(format.convert(value[i]));
								return result.substring(2);
							}
						}
						return "";
					};
				}

				// Choice Field
				else if (Cognito.config.flags.ImagesInChoiceFields && f.ChoiceShowImages && fieldType === "Choice" && f.Choices.some(function(choice) { return choice.Image })) {
					cssClass = "c-choice-with-image";

					var choiceOptions = f.Choices;

					if (isMultiSelect(fieldSubType)) {
						// Will display each selected choice's image
						formatter = function (row, cell, value) {
							if (!(value instanceof Array))
								return "";

							if (value.length === 0)
								return;

							var choiceSelections = [];

							for (var i = 0; i < value.length; i++) {
								var choice = value[i];

								var isLast = i === value.length - 1;
								var choiceWithImageElement = buildChoiceWithImageElement(choice, choiceOptions, isLast);

								choiceSelections.push(choiceWithImageElement);
							}

							var prefix = "<div class=\"cog-choice-with-image-cell\"><div class=\"cog-choice-with-image-cell__checkbox-selection\">";
							var suffix = "</div></div>"
							var choiceImageTextPairs = choiceSelections.join("</div><div class=\"cog-choice-with-image-cell__checkbox-selection\">");

							return prefix + choiceImageTextPairs + suffix;
						};
					} else {
						formatter = function (row, cell, value) {
							if (!value)
								return;

							var choiceWithImageElement = buildChoiceWithImageElement(value, choiceOptions, true);

							return "<div class=\"cog-choice-with-image-cell\">" + choiceWithImageElement + "</div>";
						};
					}
				}

				else if (fieldType === "Choice" && isMultiSelect(fieldSubType)) {
					formatter = function (row, cell, value) {
						if (!value || !value.length)
							return "";
						return htmlEscape(value.join(", "));
					};
				}

				else if (fieldType == "Lookup" && f.MappedFileUploadPath) {
					formatter = function (row, cell, value) {
						if (!value) return "";

						var imageData = getEntryFieldValue(f.MappedFileUploadPath, value);

						if (imageData)
							return buildLookupWithImageCell(value, imageData, format, f.MappedFileUploadPath);
						else
							return htmlEscape(format.convert(value));
					};
					cssClass = "c-lookup-with-image";
				}

				else if (format)
					formatter = function (row, cell, value) {
						return htmlEscape(format.convert(value));
					};

				// Add Column
				gridColumns.push({
					id: f.Id,
					name,
					toolTip,
					field: f.property,
					depth: f.depth,
					formatter,
					headerCssClass: cssClass + " c-view-column",
					cssClass,
					width: f.Width,
					sortable: true,
					defaultSortAsc,
					autoSizePadding: f.Id === 'Entry.Status' && Cognito.Forms.model.statusMap ? 20 : 0
				});
			});
			return gridColumns;
		}

		var entryIds = [];
		var loaded = {};
		var loadingEntryStates = false;

		function buildAvatarElement(entryRow, label, mappings, nameComposite) {
			var mappedImageFieldPath = mappings.MappedImageFieldPath;
			var avatarFileId = null;
			var avatar;
			var className;

			// Try to get the uploaded image if there's a mapped file upload field
			if (mappedImageFieldPath) {
				var uploadedFiles = getEntryFieldValue(mappedImageFieldPath, entryRow);
				avatarFileId = getFirstValidAvatarFile(uploadedFiles)
			}

			var hasUploadedAvatar = !!avatarFileId;
			// Self-reference passes the Name composite directly; lookup walks the path on the target row.
			var nameField = nameComposite !== undefined && nameComposite !== null
				? nameComposite
				: getEntryFieldValue(mappings.MappedNameFieldPath, entryRow);
			var firstName = nameField && nameField.First;
			var lastName = nameField && nameField.Last;
			var fullName = (firstName || "") + " " + (lastName || "");
			var hasName = !!fullName.trim();

			const emailFieldPath = mappings.MappedEmailFieldPath;
			const email = getEntryFieldValue(emailFieldPath, entryRow);

			if (hasUploadedAvatar) {
				className = "cog-lookup-image__entries cog-avatar";
				avatar = avatarFileId;
			} else {
				className = "cog-generated-avatar";
				avatar = hasName ? getAvatarSVG({ FirstName: firstName, LastName: lastName, Email: email }) : "";
			}

			// Build out either a <div> element if using a generated avatar, or an <img> element if using an uploaded avatar
			var avatarHtml = buildAvatarHtml(avatar, avatarFileId, className, fullName);
			var nameHtml = hasName ? "<span class=\"c-person-name\">" + fullName + "</span>" : "";
			return avatarHtml + nameHtml;
		}

		function buildAvatarHtml(avatar, avatarFileId, className, fullName) {
			if (!avatar && !avatarFileId)
				return "";

			if (avatarFileId)
				return "<img class=\"" + className + "\" src=\"" + avatar + "\" title=\"" + fullName + "\"" + " height=\"50\" width=\"50\">";
			else
				return "<div class=\"" + className + "\" title=\"" + fullName + "\">" + avatar + "</div>";
		}

		function buildChoiceWithImageElement(choiceText, choiceOptions, isLast) {
			var choice = choiceOptions.find(function(choiceOption) { return choiceOption.Label === choiceText });
			var choiceImage = choice ? choice.Image : null;
			var choiceImageId = choiceImage ? choiceImage.Id: null;
			var choiceImageName = choiceImage ? choiceImage.Name : null;
			var hasChoiceImage = !!choiceImageId

			var choiceImageHtml = "";
			if (hasChoiceImage) {
				var choiceImageSrc = Cognito.getThumbnailUrl(choiceImageId, choiceImageName);
				choiceImageHtml = "<div class=\"cog-choice-image__entries\" title=\"" + choiceImageName + "\" style=\"background-image: url('" + choiceImageSrc + "'); width: 1.7em; height: 1.7em;\"></div>";
			}

			var choiceTextHtml = "<span class=\"c-choice-text\">" + choiceText + (isLast ? "" : ", ") + "</span>";

			return choiceImageHtml + choiceTextHtml;
		}

		function buildLookupWithImageCell(lookupEntry, imageData, format, fileUploadPath, skipContainer) {
			var lookupText = htmlEscape(format.convert(lookupEntry));

			var imageHtml = "";
			if (imageData) {
				var imageFileId = null;
				var imageName = null;

				if (Array.isArray(imageData) && imageData.length > 0) {
					var imageFile = imageData.find(function(file) {
						return file.ContentType && file.ContentType.startsWith('image');
					});
					imageFileId = imageFile ? imageFile.Id : null;
					imageName = imageFile ? imageFile.Name : null;
				}

				if (imageFileId) {
					var imageSrc = Cognito.getThumbnailUrl(imageFileId, imageName);
					imageHtml = "<img class=\"cog-lookup-image__entries\" src=\"" + imageSrc + "\" height=\"50\" width=\"50\">";
				}
			}

			var contentHtml = imageHtml + "<span class=\"c-lookup-text\">" + lookupText + "</span>";

			if (skipContainer)
				return contentHtml;

			return "<div class=\"cog-lookup-with-image-cell\">" + contentHtml + "</div>";
		}


		function getFirstValidAvatarFile(uploadedFiles) {
			if (!uploadedFiles || uploadedFiles.length === 0)
				return null;

			var validTypes = ["image/png", "image/jpg", "image/jpeg", "image/bmp", "image/svg+xml"]

			// Users can upload non-image files to the mapped image field, so grab the first
			// valid image uploaded to the field
			var firstValidFileId = null;
			for (var i = 0; i < uploadedFiles.length; i++) {
				var currentFile = uploadedFiles[i];
				if (!validTypes.includes(currentFile.ContentType))
					continue;
				firstValidFileId = currentFile.Id;
				break;
			}

			if (firstValidFileId) {
				return CognitoConfiguration.SiteUrl + "forms/public/thumbnail?id=" + firstValidFileId;
			}

			return null;
		}

		function createPersonCheckboxTooltip(tooltipNames) {
			// Display first ten names, then append string denoting remaining amount to avoid tooltip getting too long
			var firstTenNames = tooltipNames.slice(0, 10);
			var remainingNames = tooltipNames.length - 10;
			var remainingNamesMessage = remainingNames > 0 ? "\n\n...and " + remainingNames + " more " + (remainingNames === 1 ? "person" : "people") : "";
			var tooltip = firstTenNames.join("\n") + remainingNamesMessage;

			return tooltip;
		}

		function getEntryFieldValue(fieldPath, entryValue) {
			// We are at the end of the path, so we can index entryValue directly without continuing to recurse
			if (!fieldPath.includes('.'))
				return entryValue[fieldPath];

			var firstPeriodIndex = fieldPath.indexOf('.');
			var nextField = fieldPath.substring(0, firstPeriodIndex);
			var remainingPath = fieldPath.substring(firstPeriodIndex + 1);

			return getEntryFieldValue(remainingPath, entryValue[nextField]);
		}

		function handleLookupFieldMouseEnter(event) {
			var cell = grid.getCellFromEvent(event);
			var node = grid.getCellNode(cell.row, cell.cell);

			var isPersonFieldCell = node.classList.contains('c-person');
			var isLookupWithImageCell = node.classList.contains('c-lookup-with-image');

			if (!isPersonFieldCell && !isLookupWithImageCell)
				return;

			if (isPersonFieldCell) {
				var checkboxNameNodes = node.querySelectorAll('.c-person-name');

				checkboxNameNodes.forEach(function (span) {
					if (span.scrollWidth > span.clientWidth)
						span.title = span.innerText
					else
						span.title = "";
				});

				var isCheckboxCell = !!node.querySelector('.cog-person-field-cell__checkbox-selection');
				if (isCheckboxCell) {
					const checkboxNameNodes = node.querySelectorAll('.c-person-name');
					const checkboxNames = [...checkboxNameNodes];
					var names = checkboxNames.map(function (nameNode) {
						return nameNode.innerText;
					});

					var tooltip = createPersonCheckboxTooltip(names);

					var hasOverflowingChild = checkboxNames.some(function (child) {
						return child.scrollWidth > child.clientWidth;
					});

					if (hasOverflowingChild)
						node.title = tooltip;
					else node.title = "";
				}
			}
			if (isLookupWithImageCell) {
				var checkboxTextNodes = node.querySelectorAll('.c-lookup-text');

				checkboxTextNodes.forEach(function (span) {
					if (span.scrollWidth > span.clientWidth)
						span.title = span.innerText
					else
						span.title = "";
				});

				var isCheckboxCell = !!node.querySelector('.cog-lookup-with-image-cell__checkbox-selection');

				if (isCheckboxCell) {
					var checkboxSelections = node.querySelectorAll('.cog-lookup-with-image-cell__checkbox-selection');
					checkboxSelections.forEach(function (selectionDiv) {
						var textNode = selectionDiv.querySelector('.c-lookup-text');
						var imageNode = selectionDiv.querySelector('.cog-lookup-image__entries');

						if (textNode && imageNode) {
							imageNode.title = textNode.innerText;
						}

						selectionDiv.title = "";
					});

					node.title = "";
				}
			}
		}

		Cognito.Messaging.addHandler("readStateUpdated", function (checkEntryIds) {
			var entriesInView = Cognito.Forms.model.entries.indexList.map(x => x.EntityId);
			entryIds.concat(checkEntryIds.filter(id => entriesInView.includes(id)));

			if (!loadingEntryStates) {
				loadingEntryStates = true;
				setTimeout(getEntryReadStates)
			}
		});

		function addEntryToBatch(entryId) {
			if (loaded[entryId])
				return;

			loaded[entryId] = true;
			if (!loadingEntryStates) {
				loadingEntryStates = true;
				setTimeout(getEntryReadStates);
			}

			entryIds.push(entryId);
		}

		function getEntryReadStates() {
			if (!canManageEntries.value)
				entryIds.forEach(function (e) { return readStates[e] = true });
			else if (!disableUnreadEntryTracking.value) {
				while (entryIds.length > 0) {
					var thisBatch = entryIds.splice(0, 100);
					Cognito.Forms.serviceRequest({
						endpoint: "UnreadEntries",
						method: "POST",
						data: { Entries: thisBatch },
						success: checkGrid(function (data) {
							var activeRow = grid.getActiveCell() ? grid.getActiveCell().row : undefined;
							for (var i = 0; i < thisBatch.length; i++) {
								var entryId = thisBatch[i];

								readStates[entryId] = !data.includes(entryId);

								// If the entry is currently on the grid, invalidate the row
								var index = entrySet.indexOfEntryId(entryId);
								if (index !== undefined)
									grid.invalidateRow(index);

								if (activeRow && index == activeRow) {
									var entryKey = entrySet.entryKeyAt(activeRow);
									entryKey.Read = readStates[entryId];
									controller.viewEntry(entryKey);
								}
							}
							grid.render();
						}),
						error: function () { }
					});
				}
			}
			else {
				grid.render();
			}

			loadingEntryStates = false;
		}

		// Binds the grid to the specified set of entries
		function bindGrid(newEntrySet) {

			Cognito.Forms.model.entries = entrySet = newEntrySet;

			entrySet.getLength = function getLength() { return entrySet.size(); };
			entrySet.getItem = function getItem(index) {
				addEntryToBatch(entrySet.entryKeyAt(index).EntryId)
				const entry = entrySet.entryAt(index, checkGrid(function (entry) {
					grid.invalidateRow(index);
					if (!loading) {
						loading = true;
						requestAnimationFrame(checkGrid(function () {
							loading = false;
							grid.render();
						}), 0);
					}
				}));

				// Don't allow the grid to bind to an entry that is still initializing
				if (entry && entrySet.isEntryInitialized(entry))
					return entry;
				else
					return undefined;
			};
			entrySet.getItemMetadata = function getItemMetadata(index) {
				var entry = entrySet.entryAt(index);
				if (entry) {
					var state = readStates[entry.Id] === false && !disableUnreadEntryTracking.value ? 'c-state-unread' : 'c-state-read';
					var statusName = entry.Entry.Status;
					var statusColorClass = Cognito.Forms.model.statusMap ? ' c-status-id--' + Cognito.Forms.model.statusMap[statusName] : '';
					statusName = htmlEscape(statusName);
					var statusClass = statusName.toLowerCase() === 'incomplete' ? ' c-status-incomplete' : '';
					return { cssClasses: state + statusClass + statusColorClass };
				}
				else
					return { cssClasses: "c-loading" };
			};

			// Bind the grid
			grid.setData(entrySet);
			Cognito.ready('init-grid');

			// Refresh the grid
			refreshGrid();

			// Render the grid
			grid.render();

			document.getElementById('grid').classList.remove('c-hide-entries-grid');

			stopTrackingGridReady();

			const isTaskView = entrySet
				? Cognito.Forms.model.views.some(view => (view.Id === entrySet.view) && view.IsTaskView)
				: false;

			const gridData = getGridData();
			emitPageReady({properties: { ...gridData.properties, type: isTaskView ? 'Task View' : 'Grid View' }, measurements: gridData.measurements });
		}

		function getPreviewEntrySet(baseViewData) {
			var currentViewData = Cognito.serialize(currentView);
			baseViewData = baseViewData || currentViewData;

			return AdminForm.getPreviewEntrySet(
				baseViewData.Id,
				baseViewData.Token,
				Cognito.Forms.model.allEntriesToken,
				baseViewData,
				currentViewData,
				getSortCriteria(currentView.get_SortBy().slice()),
				entrySet.role,
				{ Name: userName.value, Email: userEmail.value },
				currentView.get_isUserSpecific() ? shortUserId : null
			);
		}

		function refreshGrid(trackRefresh = false) {
			// refresh the current key to ensure it has the latest etag
			currentEntryKey = getCurrentEntryKey();
			var views = getEntryViews(Cognito.Forms.model.currentForm.get_Id())
			ExoWeb.Observer.setValue(Cognito.Forms.model, "views", views);

			// Update the entry count
			controller.updateEntryCount(entrySet.size());

			if (currentFilterInvalid) {
				// Display Invalid Filter Message
				updateProgressMessage("Invalid Filter");
			} else {
				// Hide Progress Messages
				updateProgressMessage();
			}
			// Update selected entries and the current entry
			updateSelectedEntries(selectedEntries, currentEntryKey);

			// Update the grid
			grid.invalidate();
			grid.render();

			document.querySelector('.c-entries-grid').setAttribute('data-test-refreshed', Date.now().toString());

			if (trackRefresh) {
				stopTrackingGridReady();
			}

			// Track the completion of the refresh request
			refreshing = false;

			// if entry details page is open, attempt to refresh the entry details page as well
			if (currentEntryKey && Cognito.config.role !== "Guest")
				controller.updateEntryDetails(currentEntryKey);
		}

		function getCurrentEntryPosition() {
			return currentEntryKey ? entrySet.indexOfEntryId(currentEntryKey.EntryId) : -1;
		}

		function getCurrentEntryKey() {
			var position = getCurrentEntryPosition();
			return position >= 0 ? entrySet.entryKeyAt(position) : null;
		}

		// Update the set of entries that are selected in the grid
		function updateSelectedEntries(selected, current) {
			Cognito.ready(null, ['init-grid'], checkGrid(function () {
				// "Queue" another update to ensure the entry is selected when its loaded and exit immediately if the selection is already being updated
				if (selectedEntries.updating) {
					setTimeout(() =>
						updateSelectedEntries(
							grid.getSelectedRows().map((row) => entrySet.entryKeyAt(row)),
							grid.getActiveCell() ? entrySet.entryKeyAt(grid.getActiveCell().row) : null
						)
					);
					return;
				}

				var rowKeyPairs = [];
				// Determine the current, active and new row numbers
				var currentRow = currentEntryKey ? getCurrentEntryPosition() : undefined;
				var activeRow = grid.getActiveCell() ? grid.getActiveCell().row : undefined;
				var newRow = current ? entrySet.indexOfEntryId(current.EntryId) : undefined;

				// Update the set of selected entries in the grid
				var currentRows = grid.getSelectedRows();
				var newRows = [];
				var initialCount = selected.length;
				for (var i = selected.length - 1; i >= 0; i--) {
					var key = selected[i];
					var row = entrySet.indexOfEntryId(key.EntryId);
					if (row != undefined) {
						newRows.splice(0, 0, row);
						rowKeyPairs.push([row, key]);
					}
					else
						selected.splice(i, 1);
				}

				// After getting currentRows from slickgrid and building out newRows
				// We need to ensure currentRows doesn't have the last index selected as
				// the lowest index (used for shift+clicking more entries) before we compare
				if (currentRows.length > 1 && currentRows.at(-1) < currentRows.at(-2))
					currentRows.unshift(currentRows.pop());

				// Determine if any selection changes have been made
				var selectionChanged = newRows.length != currentRows.length || selected.length != selectedEntries.length || selected.length != initialCount;
				if (!selectionChanged) {
					for (let row of currentRows){
						if(!newRows.includes(row)) {
							selectionChanged = true;
							break;
						}
					}
				}

				if (!selectionChanged) {
					for (let row of selected){
						if(!selectedEntries.find(r => r.EntryId === row.EntryId && r.Scope === row.Scope)){
							selectionChanged = true;
							break;
						}
					}
				}

				// Determine if the current row has changed
				var rowChanged = currentRow != newRow || activeRow != newRow;

				// Exit immediately if no changes occurred
				if (!selectionChanged && !rowChanged)
					return;

				// keep selected entries list ordered by their grid position
				selectedEntries = rowKeyPairs.slice()
					.sort(function (a, b) { return a[0] - b[0]; })
					.map(function (pair) { return pair[1]; });
				selectedEntries.updating = true;

				// Update the grid unless grid updates are suppressed
				currentEntryKey = current;
				if (newRow !== undefined) {
					if (rowChanged) {
						grid.scrollRowIntoView(newRow);
						grid.setActiveRow(newRow);
						if (!newRows.length)
							newRows.push(newRow);
					}

					grid.setSelectedRows(newRows);
				}
				else {
					grid.resetActiveCell();
					grid.setSelectedRows(newRows);
				}

				// Notify the controller which entries are selected
				if (selectionChanged)
					controller.selectEntries(selectedEntries);

				// Mark the update as complete
				selectedEntries.updating = false;
			}));
		}

		// Update the grid sort indicators
		function updateSortIndicators(columns) {
			// Sort by entry number descending if no sort is specified
			if (columns.length == 0)
				columns = [new Cognito.Forms.EntryViewSort({ FieldId: "Entry.Number", Ascending: false })];

			var gridCols = grid.getColumns();
			var sortCols = columns
				.filter(function (c) { return !!gridCols[grid.getColumnIndex(c.get_FieldId())]; })
				.map(function (c) { return { columnId: c.get_FieldId(), sortCol: gridCols[grid.getColumnIndex(c.get_FieldId())], sortAsc: c.get_Ascending() }; });
			grid.setSortColumns(sortCols);
		}

		// Creates a sort function based on
		function getSortCriteria(columns) {
			// Lookup fields for each column
			var sortByEntryNumber;
			for (var c = 0; c < columns.length; c++) {
				var column = columns[c];
				sortByEntryNumber = sortByEntryNumber || (column.get_FieldId() == "Entry.Number");
				for (var f = 0; f < fieldInfos.length; f++) {
					var fieldInfo = fieldInfos[f];
					if (fieldInfo.Id == column.get_FieldId()) {
						column.field = fieldInfo;
						break;
					}
				}
			}

			// Ensure entries are always sorted by entry number in some way
			if (!sortByEntryNumber) {
				var entryNumberColumn = new Cognito.Forms.EntryViewSort({ FieldId: "Entry.Number", Ascending: false });
				entryNumberColumn.field = fieldInfos.filter(function (f) { return f.Id == "Entry.Number"; })[0];
				columns.push(entryNumberColumn);
			}

			// Define sort key functions
			var culture = Sys.CultureInfo.CurrentCulture.name;
			for (let i = 0, l = columns.length; i < l; i++) {
				var property = columns[i].field.property;
				if (property.isList) {
					if (property.propertyType.name === 'FileDataRef')
						columns[i].sortCompare = function (field, value1, value2) {
							return value1.length === value2.length ? 0 : value1.length > value2.length ? 1 : -1;
						};
					else
						columns[i].sortCompare = function (field, value1, value2) {
							return value1.toString().localeCompare(value2.toString(), culture, { sensitivity: 'base' });
						};
				}
				else if (entrySet.isEntityType(property.propertyType))
					columns[i].sortCompare = function (field, value1, value2) {
						return field.property.format.convert(value1).localeCompare(field.property.format.convert(value2), culture, { sensitivity: 'base' });
					};
				else if (property.propertyType === String)
					columns[i].sortCompare = function (field, value1, value2) {
						return (value1 || '').localeCompare(value2 || '', culture, { sensitivity: 'base' });
					};
				else if (property.propertyType === Number)
					columns[i].sortCompare = function (field, value1, value2) {
						if (value1 == null)
							value1 = -Number.MAX_VALUE;
						if (value2 == null)
							value2 = -Number.MAX_VALUE;
						return value1 === value2 ? 0 : value1 > value2 ? 1 : -1;
					};
				else if (property.propertyType === Date)
					columns[i].sortCompare = function (field, value1, value2) {
						value1 = value1 == null ? -Number.MAX_VALUE : value1.getTime();
						value2 = value2 == null ? -Number.MAX_VALUE : value2.getTime();
						return value1 === value2 ? 0 : value1 > value2 ? 1 : -1;
					};
				else
					columns[i].sortCompare = function (field, value1, value2) {
						return value1 === value2 ? 0 : value1 > value2 ? 1 : -1;
					};
			}

			// Sort Criteria
			return function (entry1, entry2) {
				for (var i = 0, l = columns.length; i < l; i++) {
					var column = columns[i];
					var sign = column.get_Ascending() ? 1 : -1;
					var field = column.field;
					var result = column.sortCompare(field, field.property.value(entry1), field.property.value(entry2)) * sign;
					if (result != 0) {
						return result;
					}
				}
				return 0;
			}
		}

		// Shows/hides/updates wait progress messages for long-running grid operations
		function updateProgressMessage(message, callback) {
			const isEmpty = entrySet ? entrySet.size() === 0 : true;
			const isTaskView = entrySet
				? Cognito.Forms.model.views.some(view => (view.Id === entrySet.view) && view.IsTaskView)
				: false;

			const showNoResults = !message && isEmpty;

			$("#progress")
				.toggleClass("c-progress-message", !!message)
				.toggleClass("c-progress-no-entries-found", showNoResults)
				.toggleClass("c-progress-no-entries-found--task-view", showNoResults && isTaskView)
				.removeClass("c-entries-loading", !message);

			$("#progress span").text(message || "");
			if (message === "Invalid Filter") {
				$("#progress").addClass('filter--invalid');
			} else {
				$("#progress").removeClass('filter--invalid');
			}
			if (callback)
				window.setTimeout(callback);
		}

		// Escape HTML tags to prevent issues when building HTML to display in the grid
		function htmlEscape(str) {
			return String(str)
				.replace(/&/g, '&amp;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;');
		}

		// Stops tracking the grid ready time and reports it to app insights
		function stopTrackingGridReady() {
			if (appInsights && tracking) {
				const gridData = getGridData();
				const props = { ...gridData.properties, ...gridData.measurements };
				appInsights.stopTrackEvent('TimeToGridReady', props);
				tracking = false;
				indexesBuilt = false;
				if (source == 'Initial Load')
					source = 'Other';
			}
		}

		function getGridData() {
			const numberOfViewColumns = grid.getColumns().length;
			const entryViewId = currentView.get_Id();
			const numberOfViewEntries = entrySet.size();
			const numberOfFormFields = Cognito.Forms.model.currentForm.get_Fields().length;
			const hasLookups = Cognito.Forms.model.currentForm.get_HasLookups();
			return {
				properties: { FormId: entryViewId.split('-')[0], entryViewId, indexesBuilt, hasLookups, origin: source },
				measurements: { numberOfViewColumns, numberOfViewEntries, numberOfFormFields }
			};
		}

		shortUserId = Cognito.Forms.model.shortUserId;
		// #endregion

		Cognito.ready("Cognito.Forms.gridController", ["Cognito.Forms.controller"], function () {

			// Define controller variable if needed
			if (!controller)
				controller = Cognito.Forms.controller;

			// Tell the top controller the grid is ready
			controller.initMaster(Cognito.Forms.gridController);
		});
	})
}
